<sc-flex vertical stretchContent fitHeight>

  <sc-dialog-title>{{getTitle()}}</sc-dialog-title>



  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>

      @if (loaded) {
        @if (errorMsg != null) {
          <div class="error-message">
            <sc-padding>{{errorMsg}}</sc-padding>
          </div>
        }
        <sc-padding>
          <sc-flex >
            @for (viewModel of visibleViewModels; track viewModel) {
              <app-document-item [viewModel]="viewModel" [allowAdd]="data.addDocumentsEnabled"
                (delete)="deleteDocument(viewModel)" (click)="setSelectedModel(viewModel)">
              </app-document-item>
              <sc-content-spacer></sc-content-spacer>
            }
            @if (this.data.addDocumentsEnabled) {
              <div class="add-button-area">
                <div (click)="addDocument()" class="add-document-btn">
                  <sc-icon iconClass="fa-plus"></sc-icon>
                </div>
              </div>
            }
          </sc-flex>
          <sc-content-spacer vertical></sc-content-spacer>
          @for (viewModel of visibleViewModels; track viewModel) {
            <form [formGroup]="viewModel.form" [hidden]="!viewModel.selected">
              <app-document [form]="viewModel.form" [document]="viewModel.document"
              (documentChanged)="viewModel.onDocumentChanged()" [metaData]="data.metaData"></app-document>
            </form>
          }
        </sc-padding>
      }

    </sc-scroll-pane>
  </sc-flex-fitting-content>


  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-close-button (click)="close()"></sc-close-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button [disabled]="isSaveDisabled()" (click)="save()"></sc-save-button>
    </sc-flex>
  </sc-padding>
</sc-flex>
